// extracted by mini-css-extract-plugin
export default {"container":"Infobox_container__7G9HB","portrait":"Infobox_portrait__o0nYl","animation":"Infobox_animation__cm28X"};